import { useCallback } from "react";
import { useWebSocketContext } from "../providers/WebSocketContextProvider";

// @deprecated. Still used by SubFolder only to call wsCreateFolder, wsDeleteFolder.
//              - Should be replcaed with sendMessage in useWebSocketCaller.
//              - Keep it as reference for the wsCalls... commands.
export default function useWebSocketOps() {      

  // ------      useWebSocketContext     ------
  const {getStompClient} = useWebSocketContext();

  const wsSendMessage = useCallback((appEndPoint, msgObj) => {
    if (getStompClient()) {
      getStompClient().send('/app/'+appEndPoint, JSON.stringify(msgObj));
    }
    else {
      console.warn('stompClient not initialized. canceling send request for [endpoint: %s] [msgObj]', appEndPoint, JSON.stringify(msgObj));
    }
  }, [getStompClient]);

  const wsCreateFolder = useCallback((path, oldFolderName, newFolderName) => {
    if (getStompClient()) {
      if (oldFolderName) {
        getStompClient().send('/app/rename-config-folder', JSON.stringify({'parentPath': path, 'oldFolderName':oldFolderName, 'newFolderName':newFolderName}));
      }
      else {
        getStompClient().send('/app/create-config-folder', JSON.stringify({'path': path, 'folder':newFolderName}));
      }      
    }
    else {
      console.warn('stompClient not initialized. canceling send to Create Folder.');
    }
  }, [getStompClient]);

  const wsUserSayHi = useCallback((msg) => {
    if (getStompClient()) {
      getStompClient().send('/app/chat-say', JSON.stringify({'msg': msg}));
    }
    else {
      console.warn('stompClient not initialied yet. Skipping user request to say hi!');
    }
  }, [getStompClient]);

  const wsTellUser = useCallback((targetUser, msg) => {
    if (getStompClient()) {
      getStompClient().send('/app/tell-user', JSON.stringify({'targetUsername':targetUser, 'message':msg}));
    }
    else {
      console.warn('stompClient not initialied yet. Skipping user request for Tell-Other-User');
    }
  }, [getStompClient]);

  const wsSaveUserField = useCallback((userId, fieldName, fieldValue) => {
    if (getStompClient()) {
      const request = JSON.stringify({'userId': userId, 'fieldName': fieldName, 'fieldValue': fieldValue});
      // console.log('wsSaveUserField for UserId: '+userId+' ['+fieldName+':'+fieldValue+']');
      getStompClient().send('/app/save-user-field', request);
    }
    else {
      console.warn('StompClient not initialized! Save User Field request was NOT sent to the server.');
    }
  },[getStompClient]);

  const wsSaveItem = useCallback((basePath, oldKey, oldNodeValue, newKey, newValue) => {
    if (getStompClient()) {
      const request = JSON.stringify({basePath: basePath, key: newKey, value: newValue, kiponosInfo: oldNodeValue.kiponosInfo, oldKey: oldKey});
      // console.log('wsSaveItem request: '+request);
      getStompClient().send('/app/save-config-prop', request);
    }
    else {
      console.warn('My WARN: StompClient not initialized! Save Item request was NOT sent to the server.');
    }
  }, [getStompClient]);

  // const wsDeleteItem = useCallback((basePath, key) => {
  //   if (getStompClient()) {
  //     const request = JSON.stringify({basePath: basePath, key: key});
  //     getStompClient().send('/app/delete-config-prop', request);
  //   }
  //   else {
  //     console.warn('StompClient not initialized! Delete Item request was NOT sent to the server.');
  //   }
  // }, [getStompClient]);

  const wsDeleteFolder = useCallback((basePath, folderName) => {
    if (getStompClient()) {
      getStompClient().send('/app/delete-config-folder', JSON.stringify({'basePath': basePath, 'folderName': folderName}));
    }
    else {
      console.warn('StompClient not initialized. Aborting Delete-Folder.');
    }
  }, [getStompClient]);

  const wsInvite = useCallback((email, firstName, teamId, username = '', whenClickedNotifyMe = true, whenClickedHoldForMyApproval = false) => {
    if (getStompClient()) {
      getStompClient().send('/app/invite', 
                                  JSON.stringify({
                                                    'toEmail': email, 
                                                    'toFirstName': firstName, 
                                                    'toTeamId':teamId, 
                                                    'toUsername': username, 
                                                    'whenClickedNotifyMe': whenClickedNotifyMe, 
                                                    'whenClickedHoldForMyApproval': whenClickedHoldForMyApproval
                                                }));
    }
    else {
      console.warn('StompClient not initialized. Aborting Send Invite.');
    }
  }, [getStompClient]);

  
  const wsGetTeamInfo = useCallback((teamId, username, accountId) => {
    if (getStompClient()) {
      getStompClient().send('/app/get-team-info', 
      JSON.stringify({
        'teamId': teamId,
        'username': username,
        'accountId': accountId
      }));
    }
    else {
      console.warn('StompClient not initialized. Aborting Get Team Info');
    }
  }, [getStompClient]);

  const wsGetInvites = useCallback((teamId, username, accountId) => {
    if (getStompClient()) {
      getStompClient().send('/app/get-my-invites',
        JSON.stringify({
          'teamId': teamId,
          'username': username,
          'accountId': accountId
        })
      );
    }
    else {
      console.warn('StompClient not initialized. Aborting Get My Invites');
    }
  }, [getStompClient]);

  // ---  Return ---
  return {  
    wsSendMessage,    
    wsCreateFolder,    
    wsDeleteFolder,
    // wsDeleteItem,
    wsGetInvites,
    wsGetTeamInfo,
    wsInvite,
    wsSaveItem,
    wsSaveUserField,
    wsTellUser,
    wsUserSayHi,
  }
}






  // // UNSubscribe
  // const wsUnsubscribe = (subId, onlyIfConnected = true) => {
  //   if (!subId) {
  //     console.error('[useWebSocketOps wsUnsubscribe] Without subId!');
  //     return subId;
  //   }    
   
  //   let topicName = null;
  //   let isDeletedFromActive = false;

  //   if (isWsConnected()) {
  //     stompClientRef.current.unsubscribe(subId, {});      
  //     // get the channelName and delete the Active entry.
  //     if (hasActiveId(subId)) {
  //       topicName = subsActive[subId].topicName;
  //       delete subsActive[subId];
  //       isDeletedFromActive = true;
  //       // console.log('[useWebSocketOps wsUnsubscribe] Unsubscribed. Active Deleted %s --> %s', topicName, subId);
  //     }
  //     else {
  //       console.error('[useWebSocketOps wsUnsubscribe] Connected but no Active subId: %s', subId);
  //     }
  //   }
  //   else {
  //     if (onlyIfConnected) {
  //       throw new Error("[useWebSocketOps wsUnsubscribe] Disconnected but 'onlyIfConnected' requested!");
  //     }
  //   }

  //   //--- Here do - whether connected or not:
    
  //   setWebSocketReady(false); // should be "channelReady" ??  not websocket ready becasue it means the channels are subscribed.
    
  //   // If channel not found (not active), Search the Queue...
  //   let data;
  //   let isFoundInQueue = false;
  //   if (topicName === null) {
  //     const entry = Object.entries(subsQueue).find(e => e[1].id === subId);
  //     topicName = entry?.[0];
  //     data = JSON.stringify(entry?.[1]);
  //     isFoundInQueue = Boolean(topicName) && Boolean(data);
  //   }
    
  //   if (!isDeletedFromActive && !isFoundInQueue) {
  //     console.error('[useWebSocketOps wsUnsubscribe] BUG / Wrong usage: subId not deleted from Active and not found in Queue [topicName: %s] [subId: %s]', topicName, subId);
  //   }

  //   if (isDeletedFromActive && isFoundInQueue) {
  //     console.error('[useWebSocketOps wsUnsubscribe] BUG? both in active list and still in queue is possible but not likely so please check [topicName: %s] [subId: %s]', topicName, subId);
  //   }

  //   delete subsQueue[topicName];
  //   // console.log('[useWebSocketOps wsUnsubscribe] Queue Entry Deleted [topicName: %s] [queueEntry: %s] [Active Deleted: %s] [Queue Deleted: %s]', topicName, data, isDeletedFromActive, isFoundInQueue);
  // }

  // //
  // // ---[  Stomp SUBSCRIBE  ]---
  // //
  // const stompSubscribe = (subsId, channelName, onMsg) => {
  //   // SUBSCRIBE
  //   const subRes = stompClientRef.current.subscribe(channelName, onMsg, {'id': subsId});

  //   // subId ==> ActiveData
  //   subsActive[subRes.id] = {
  //     id: subRes.id,
  //     topicName: channelName
  //   };
    
  //   // Remove it from the Queue.
  //   delete subsQueue[channelName];
  // }
  

  // // 
  // // ---[  onConnect  ]---
  // //
  // // Subscribe all pending requests.
  // // onClose for now is handled the same as onError 
  // // 
  // const onConnect = () => {
  //   setWsConnected();
  //   //dispatchSubscribe();
  //   Object.keys(subsQueue).forEach(topic => {
  //     const subReqData = subsQueue[topic];
  //     stompSubscribe(subReqData.id, topic, subReqData.onMsg);
  //   });    

  //   Object.keys(subsActive).forEach(subKey => console.log('[useWebSocketOps onConnect] ACTIVE - %s --> %s', subKey, JSON.stringify(subsActive[subKey])));    
  //   stompClientRef.current.ws.onclose = onError;
  //   setWebSocketReady(true);
  //   dispatchWebSocketAutoSend();
  // }


  // // On Error, we can not recover (auto reconnect) as we don't have the httpOnly cookie, so must re-login.
  // const onError = (event) => {
  //   console.error('WebSocket Connection ERROR:'+JSON.stringify(event));
  //   setWsConnectionError();
  //   disconnect();
  //   setWebSocketReady(false);
  //   dispatchWebSocketError();
  //   return;
  // }


  // //
  // // ---[  Disconnect  ]----
  // // 
  // const disconnect = () => {
  //   Object.keys(subsActive).forEach(subnId => {
  //     wsUnsubscribe(subnId);
  //   }); 

  //   if (stompClientRef?.current && isWsConnected()) {  
  //     if (stompClientRef.current) {
  //       stompClientRef.current.disconnect(onDisconnect, {});
  //     }
  //   }
  // }


  // //
  // // ---[  onDisconnect  ]---
  // //
  // const onDisconnect = () => {    
  //   setWsDisconnected();
  //   ejectClient();
  //   setWebSocketReady(false);
  //   // dispatch WebSocket Disconnected()..
  // }
  

  //
  // ---[  Send Message  ]---
  //


  // const wsSendMessageORIG = (appEndPoint, msgObj) => {
  //   if (stompClientRef.current) {
  //     stompClientRef.current.send('/app/'+appEndPoint, JSON.stringify(msgObj));
  //   }
  //   else {
  //     console.warn('stompClient not initialized. canceling send request for [endpoint: %s] [msgObj]', appEndPoint, JSON.stringify(msgObj));
  //   }
  // }


  
  // Create Or Rename Folder
  

